import MUIButton from '@mui/material/Button'
import React from 'react'

export interface ButtonProps extends React.ComponentProps<typeof MUIButton> {}

export const Button: React.FC<ButtonProps> = (props) => {
  return <MUIButton variant={'outlined'} {...props} />
}
